import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import {
   getCompanyAutosuggestJF,
} from 'app/services/partner/autosuggest';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';

const CompanyAutosuggestJF = autosuggestFactory({
   apiPromise: getCompanyAutosuggestJF,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndNameAsLabel,
   defaultPlaceholder: 'Search Hiring Company...',
});

export default withAutosuggestWrapper(withInputErrorMessage(CompanyAutosuggestJF));
